import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgBlockUI, BlockUI } from 'ng-block-ui';
import { LoginService } from 'src/app/Services/login.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
  selector: 'ppa-recuperar-senha',
  templateUrl: './recuperar-senha.component.html',
  styleUrls: ['./recuperar-senha.component.css']
})
export class RecuperarSenhaComponent implements OnInit {

  formRecuperarSenha: FormGroup;
  @BlockUI() blockUI: NgBlockUI;
  emailPattern = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  
  constructor(private formBuild: FormBuilder, private loginService: LoginService, private toast: ToastrService, private rota: Router) { }

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.formRecuperarSenha = new FormGroup({
      cpf: this.formBuild.control('', Validators.required),
      email: this.formBuild.control('', [Validators.required, Validators.pattern(this.emailPattern)])
    });
  }

  recuperSenha() {
    if(this.formRecuperarSenha.invalid){

      if (this.formRecuperarSenha.controls['cpf'].invalid && this.formRecuperarSenha.controls['email'].invalid)
        this.toast.error('Preencha todos os campos do formulário corretamente para recuperar a senha.', 'Atenção', { enableHtml: true });
      else if (this.formRecuperarSenha.controls['cpf'].invalid)
        this.toast.error('Informe o campo CPF.', 'Atenção', { enableHtml: true });
      else if (this.formRecuperarSenha.controls['email'].invalid)
        this.toast.error('Informe o campo E-mail corretamente.', 'Atenção', { enableHtml: true });  

      return;
    }
    
    

    this.blockUI.start('Aguarde...');

    var cpf = this.formRecuperarSenha.value.cpf;
    var email = this.formRecuperarSenha.value.email;

    this.loginService.esqueciMinhaSenha(cpf, email)
      .subscribe((response: any) => {
        console.log(response);
      }, (erroResponse: HttpErrorResponse) => {
        this.toast.error(erroResponse.error.message, 'Atenção', { enableHtml: true });
        this.blockUI.stop();
      },
    ()=> {
      setTimeout(() => {
        this.blockUI.stop();
        this.rota.navigate(['publico/login']);
        this.toast.success('Sua senha foi enviada para o e-mail informado.', 'Atenção', { enableHtml: true });
      }, 2000);
    });
  }
}
